import { Navigate } from "react-router-dom";
const Services = () => <Navigate to="/#services" replace />;
export default Services;
